import { normalizeAssetKeyQuery } from '@/features/assets/lib/assetKeyQuery';
import type { AssetCatalogFilters } from '@/features/assets/types/asset';

export function serializeAssetCatalogFilters(filters: AssetCatalogFilters) {
  return {
    q: normalizeAssetKeyQuery(filters.q) ?? undefined,
    organizationId: filters.organizationId || undefined,
    projectId: filters.projectId || undefined,
    minDurationMs: filters.minDurationMs,
    maxDurationMs: filters.maxDurationMs,
    minSizeBytes: filters.minSizeBytes,
    maxSizeBytes: filters.maxSizeBytes,
    rejected: filters.rejected,
    metadata: filters.metadata ?? {},
    metadataPresent: filters.metadataPresent ?? {},
    delivery: filters.delivery ?? 'all',
    deliveryOperator: filters.deliveryOperator ?? 'in',
    // Part of the cache key: each field and direction owns its cursor chain.
    sort: filters.sort ?? null,
  };
}
